import { Flex, IconButton, Link, ListItem } from "@chakra-ui/react";
import { Item } from "./types/item";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { useEffect, useState } from "react";
import { Text } from "@chakra-ui/react";
import { supabase } from "index";

type TrackRecordFileTemplateProps = {
  item?: Item;
};

export const TrackRecordFileTemplate = ({ item }: TrackRecordFileTemplateProps) => {
  const { user } = useTenant();
  const [url, setUrl] = useState<string>();

  useEffect(() => {
    if (!isApplicable(item)) {
      return;
    }

    const fetchUrl = async () => {
      const { data } = await supabase.storage.from("templates").createSignedUrl(
        `${user?.lender_company?.id}/checklist_items_defaults/Borrower Track Record Template.xlsx`,
        60 * 60 * 24 // 1 day
      );

      setUrl(data?.signedUrl);
    };

    fetchUrl();
  }, [user, item]);

  if (!url) {
    return null;
  }

  return (
    <ListItem py="12px" borderColor="gray.50" borderBottomWidth="1px">
      <Flex justifyContent="space-between" fontSize="14px" alignItems="center">
        <Link target="_blank" href={url}>
          Borrower Track Record Template.xlsx
        </Link>
        <Flex alignItems="center">
          <Text>30.9KB</Text>
          <IconButton
            disabled={true}
            width="9px"
            height="9px"
            aria-label="remove-file"
            variant="ghost"
            title="This file is fixed and cannot be removed"
            icon={<FontAwesomeIcon icon={["fal", "times"]} />}
          />
        </Flex>
      </Flex>
    </ListItem>
  );
};

export function isApplicable(item: Item | undefined): boolean {
  if (!item) {
    return false;
  }

  return (
    item.category === "Track Record" &&
    item.type === "tasks" &&
    item.title === "Experiences Verified Through Reliable Sources"
  );
}
